// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { PFixFieldSet } from '../Fields/FieldsImport';
import { FieldsFactory } from '../Factory/FieldsFactory';
export class BuyingPowerAvailableFundsForEquitiesGroup extends PFixFieldSet {
    constructor(pfixFieldSet) {
        super(FieldsFactory.BUYING_POWER_AVAILABLE_FUNDS_FOR_EQUITIES, null, pfixFieldSet);
    }
    getBuyingPowerName() {
        return this.GetValue(FieldsFactory.FIELD_NAME);
    }
    getAvailableFunds() {
        return this.GetValue(FieldsFactory.FIELD_AVAILABLE_FUNDS);
    }
}
